import { parse } from 'querystring'
import lodash from 'lodash'
import qs from 'qs'
import pathRegexp from 'path-to-regexp'
import { message } from 'antd'
import { UserSnick } from '@/types/user'
import { url } from './regExps'

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/

export const pwdRule = /^(?=.*[~!@#$%^&*()_+`\-={}\[\]:;"'<>,.?\/])(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/

export const isUrl = (path: string): boolean => reg.test(path)

export const isAntDesignPro = (): boolean => {
  return window.location.hostname === 'preview.pro.ant.design'
}

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env
  if (NODE_ENV === 'development') {
    return true
  }
  return isAntDesignPro()
}

export const getPageQuery = () => parse(window.location.href.split('?')[1])

/**
 * props.route.routes
 * @param router [{}]
 * @param pathname string
 */
export const getAuthorityFromRouter = <T extends Route>(
  router: T[] = [],
  pathname: string
): T | undefined => {
  const authority = router.find(
    ({ routes, path = '/' }) =>
      (path && pathRegexp(path).exec(pathname)) ||
      (routes && getAuthorityFromRouter(routes, pathname))
  )
  if (authority) return authority
  return undefined
}

export const getRouteAuthority = (path: string, routeData: Route[]) => {
  let authorities: string[] | string | undefined
  routeData.forEach(route => {
    // match prefix
    if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
      if (route.authority) {
        authorities = route.authority
      }
      // exact match
      if (route.path === path) {
        authorities = route.authority || authorities
      }
      // get children authority recursively
      if (route.routes) {
        authorities = getRouteAuthority(path, route.routes) || authorities
      }
    }
  })
  return authorities
}

export const downloadLink = (url: string, params?: any, fileName?: string) => {
  const a = document.createElement('a')
  a.target="_blank"
  a.href = `${url}?${qs.stringify({ ...params, current_page: undefined, page_size: undefined })}`
  // a.target = '_blank';
  if (fileName) {
    a.download = fileName
  }
  document.body.appendChild(a)
  a.click()
}

export const downloadBlob = (blob: any, fileName?: string) => {
  const a = document.createElement('a')
  const url = window.URL.createObjectURL(blob)
  a.href = url
  if (fileName) {
    a.download = fileName
  }
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(url)
}

export const getTree = list => {
  const treeList: any[] = []
  const map = {}
  list?.forEach(item => {
    if (!item?.children) {
      item.children = []
    }
    map[item.department_id] = item
  })

  list?.forEach(item => {
    // 通过pid在做成的map中找到父级，将子级插入到父级中
    const parent = map[item.pid]
    if (parent) {
      parent.children.push(item)
    } else {
      treeList.push(item)
    }
  })
  return treeList
}

export const getOptions = (tree: any) => {
  tree.forEach((item: any) => {
    if (!item.children.length) {
      delete item.children
    } else {
      getOptions(item.children)
    }
  })
  return tree
}

export const getPossibleResult = (departmentList: any, checkedIds: string[]) => {
  // 取出数据权限勾选的项
  const fm = (arrRoot: any, ids: string[]) => {
    const temp: any = []
    const fn = (tree: any, arr: any[], pid: string) => {
      const newArr = arr.slice(0)
      newArr.push({ ...tree, pid })
      if (ids.includes(tree?.department_id)) {
        if (tree?.children && tree?.children.length) {
          tree?.children.forEach((element: any) => {
            fn(element, newArr, tree?.department_id)
          })
        } else {
          temp.push(newArr)
        }
      } else if (tree?.children && tree?.children.length) {
        tree?.children.forEach((element: any) => {
          fn(element, newArr, tree?.department_id)
        })
      }
    }
    fn(arrRoot, temp, '')
    return temp
  }
  const allArr = fm(departmentList?.[0], checkedIds)
  // 合并数据
  const mergeData = lodash.union(...allArr)
  // 清洗数据
  const clearResult = mergeData?.map((m: any) => {
    m.children = []
    return m
  })
  // 组成一颗新树
  const newTree = getTree(clearResult)
  // children为空的进行转化
  const result = getOptions(newTree)
  return result
}

export function handleMarkVisited(nick) {
  const iframe = document.createElement('iframe')
  iframe.src = `https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=${nick}&site=cntaobao&groupid=0&s=1`
  document.body.appendChild(iframe)
  setTimeout(() => document.body.removeChild(iframe), 1000)
}

let snicks: UserSnick[] = []
let currentUser: string
export function updateSnicks(newSnicks: UserSnick[], name: string): void {
  snicks = newSnicks
  currentUser = name
}

export function handleVisitedJD(nick, snick) {
  try {
    const pin = snicks
      .find(i => i.snick?.split(':')[0] === snick?.split(':')[0])
      ?.snick?.split(':')?.[1]
    if (!pin) {
      message.warn(`打开失败，当前登录“${currentUser}”需要绑定“${snick?.split(':')[0]}”的子账号`)
      return
    }
    JmJsBridgePC.openDD({ pin, client: nick })
  } catch (e) {
    console.log(e)
  }
}

// 兼容明察系统分页
export const formatPageInfo = params => {
  const { current_page, page_size, currentPage, pageSize, ...rest } = params || {}

  const page = current_page || currentPage
  const size = page_size || pageSize
  if (lodash.isNumber(page) && lodash.isNumber(size)) {
    const skip = (page - 1) * size
    return {
      ...rest,
      skip: skip >= 0 ? skip : 0,
      limit: size,
    }
  }
  return rest
}

export const selectNode = (e: any) => {
  const text = e.target
  if (document.body.createTextRange) {
    const range = document.body.createTextRange()
    range.moveToElementText(text)
    range.select()
  } else if (window.getSelection) {
    const selection = window.getSelection()
    const range = document.createRange()
    range.selectNodeContents(text)
    selection?.removeAllRanges()
    selection?.addRange(range)
  }
}

export const calculPlatform = (platform: string) => {
  if (platform === 'tb') {
    return '淘宝'
  } else if (platform === 'jd') {
    return '京东'
  } else if (platform === 'ks') {
    return '快手'
  } else if (platform === 'pdd') {
    return '拼多多'
  } else if (platform === 'dy') {
    return '抖音'
  } else if (platform === 'open') {
    return '开放平台'
  } else if (platform === 'wx') {
    return '企微'
  } else if (platform === 'jdqc') {
    return '京东质检'
  } else {
    return '其他'
  }
}

const imgUrls = {}
export function isImgUrl(url: string) {
  return new Promise(resolve => {
    if (!isUrl(url)) {
      resolve(false)
      return
    }
    if (imgUrls[url] === true) {
      resolve(true)
      return
    }
    if (imgUrls[url] === false) {
      resolve(false)
      return
    }
    const ImgObj = new Image() //判断图片是否存在
    ImgObj.src = url
    ImgObj.onload = () => {
      imgUrls[url] = true
      resolve(true)
    }
    ImgObj.onerror = () => {
      imgUrls[url] = false
      resolve(false)
    }
  })
}
// 字符过长设置显示长度
export const ellipsisText = (str, len = 0) => {
  if (str === undefined) return null
  if (str.length <= len) return str
  return `${str.substr(0, len + 1)}...`
}

function getBlob(url: string): Promise<Blob> {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest()

    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }

    xhr.send()
  })
}

//下载文件
export function saveAs(url: string, filename: string) {
  getBlob(url).then(blob => {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
  })
}


  // 是否使用新布局，默认使用新的
export const isNewLayout = localStorage.getItem('ums_layoutVerson') === 'v2'
export const HOME_PATH = '/workbench/index'


// dataforce页面url
// 满意度淘宝
// export const MYD_URL_TB = '/629f04d38b3dc3b2fe7a915d/629f05338b3dc3b2fe7a91c4'
export const MYD_URL_TB = isNewLayout? '/reportCenter/67d2461ce63366f0474b20b0': '/629f04d38b3dc3b2fe7a915d/67d2461ce63366f0474b20b0'
// 满意度京东
export const MYD_URL_JD = isNewLayout ? '/reportCenter/6692264d22ab8099711037a3' :'/629f04d38b3dc3b2fe7a915d/6692264d22ab8099711037a3'
// 店铺实时告警
export const SHOP_ALERT_URL = '/60b87bb27b0e79e09606bf84/60bf4f40b28f108aa02dbdf4'


export const isTest = 
// false
  window.location.host.includes('dev-lane') || window.location.host.includes('localhost')